import { Chip, Stack, Typography } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

const GOLD = '#C9A84C';
const GOLD_D = '#8b6520';

export default function ReadOnlyBanner() {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{
        px: 1.5,
        py: 0.45,
        borderRadius: '999px',
        border: `1px solid rgba(201,168,76,0.55)`,
        background: 'linear-gradient(135deg, rgba(201,168,76,0.22), rgba(139,101,32,0.12))',
        boxShadow: '0 1px 8px rgba(201,168,76,0.18)',
        whiteSpace: 'nowrap'
      }}
    >
      <VisibilityOutlinedIcon sx={{ fontSize: 18, color: GOLD_D }} />
      <Chip
        label="受限"
        size="small"
        sx={{
          height: 22,
          fontWeight: 700,
          fontSize: 12,
          color: '#fff',
          background: `linear-gradient(135deg, ${GOLD}, ${GOLD_D})`
        }}
      />
      <Typography sx={{ fontSize: 11.5, color: GOLD_D, fontWeight: 500, display: { xs: 'none', sm: 'block' } }}>
        能看后台；改价和对账可用，其它不能改
      </Typography>
    </Stack>
  );
}
